import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Popup, Button, Icon } from "semantic-ui-react";

import { operationAvailable } from "../../../utils/operations.js";

import { OPERATIONS } from "../../../constants/operations.js";
import {
  INACTIVE,
  WORKING_VALUES,
  POWER_ICON_MAP
} from "./StartStopControlConstants.js";

class StartStopPowerIconControl extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    permissions: PropTypes.object.isRequired,
    circular: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.string,
    disabled: PropTypes.bool,
    copy: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  handleButtonClick = (evt, { datamarking }) => {
    const { data, onClick } = this.props;
    onClick(data["@id"], datamarking);
  };

  renderButton(marking, circular = false, inactive = false, loading = false) {
    const { className, style, copy } = this.props;

    const label = copy[marking] || copy["default"];

    const button = (
      <Button
        icon
        circular={circular}
        labelPosition={!circular ? "right" : null}
        size={circular ? "mini" : null}
        basic={circular ? true : null}
        loading={!circular ? loading : null}
        disabled={inactive}
        className={className}
        style={style}
        datamarking={marking}
        onClick={this.handleButtonClick}
      >
        {!circular && `${label}`}
        <Icon
          name={POWER_ICON_MAP[marking].icon}
          color={POWER_ICON_MAP[marking].color}
        />
      </Button>
    );

    if (circular) {
      return (
        <Popup
          trigger={button}
          position="top center"
          size="tiny"
          offset={[1, 0]}
          hideOnScroll
          content={label}
        />
      );
    }

    return button;
  }

  renderStartStopButton() {
    let {
      data: { operations, enabledOperations, marking },
      permissions,
      circular
    } = this.props;

    if (
      operationAvailable(
        OPERATIONS.STOP,
        operations,
        enabledOperations,
        permissions
      ).available
    ) {
      return this.renderButton(OPERATIONS.STOP, circular, false);
    } else if (
      operationAvailable(
        OPERATIONS.START,
        operations,
        enabledOperations,
        permissions
      ).available
    ) {
      return this.renderButton(OPERATIONS.START, circular, false);
    } else if (WORKING_VALUES.indexOf(marking) > -1) {
      return this.renderButton(marking, circular, true, true);
    }

    return this.renderButton(INACTIVE, circular, true);
  }

  render() {
    let { data, disabled } = this.props;

    if (!data || disabled) return null;

    return this.renderStartStopButton();
  }
}

export default StartStopPowerIconControl;
